import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useDeleteDialogStyles = makeStyles(
  (theme: Theme) => {
    return {
      removeConversationDialog: {
        '& .v5-MuiPaper-root': {
          display: 'flex',
          flexDirection: 'column',
          gap: '.5rem',
          color:
            theme.palette?.mode === 'dark'
              ? 'var(--xlrt-color-ui-white)'
              : 'var(--xlrt-color-ui-gray20)',
          backgroundColor:
            theme.palette?.mode === 'dark'
              ? 'var(--xlrt-color-ui-gray25)'
              : 'var(--xlrt-color-ui-white)',
          padding: '1rem',
          borderRadius: '16px',
        },
        '& .v5-MuiDialogContent-root': {
          padding: '0',
        },
      },
      dialogPaper: {
        width: '27rem',
      },
      removeConversationDialogHeaderContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        padding: '0',
      },
      removeConversationDialogTitle: {
        '&&': {
          fontSize: '1.25rem',
          padding: '0',
        },
      },
      removeConversationDialogContent: {
        color:
          theme.palette?.mode === 'dark'
            ? 'var(--xlrt-color-ui-white)'
            : '#74757E',
        fontSize: '.875rem',
        maxWidth: '28rem',
      },
      removeConversationDialogActions: {
        padding: '1rem 0',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '20px',
        alignSelf: 'stretch',
        width: '100%',
        '& > :not(style) ~ :not(style)': {
          marginLeft: 0,
        },
      },
      removeConversationDialogBtn: {
        display: 'flex',
        borderRadius: '100px',
        padding: '0.5rem 0.75rem',
        borderColor: 'var(--xlrt-color-ui-gray60)',
        color:
          theme.palette?.mode === 'dark'
            ? 'var(--xlrt-color-ui-white)'
            : 'var(--xlrt-color-ui-gray20)',
        textTransform: 'none',
        gap: '8px',
        flex: '1 1 0',
        fontSize: '.75rem',
        fontWeight: '500',
        '&:hover': {
          borderColor: 'var(--xlrt-color-ui-gray60)',
          backgroundColor: 'inherit',
        },
      },
      removeConversationDialogBtnDelete: {
        backgroundColor: 'var(--xlrt-color-sun-red500)',
        border: 'none',
        boxShadow: 'none',
        color: 'var(--xlrt-color-ui-white)',
        '&:hover': {
          backgroundColor: 'var(--xlrt-color-sun-red500)',
          boxShadow: 'none',
        },
      },

      removeConversationDialogCloseBtn: {
        '&&': {
          color:
            theme.palette?.mode === 'dark'
              ? 'var(--xlrt-color-ui-white)'
              : 'var(--xlrt-color-ui-gray20)',
        },
      },
    };
  },
  { name: 'DeleteDialog' },
);
